import { render, staticRenderFns } from "./UnsoldArtworks.vue?vue&type=template&id=f4ccbd06"
import script from "./UnsoldArtworks.vue?vue&type=script&lang=js"
export * from "./UnsoldArtworks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports